module.exports = (__webpack_require__(87389))("./src/index.js");